module.exports = __webpack_public_path__ + "static/clarinet_en-94db1a0bfddb242ed1ecbc6072c6ff1e.pdf";